"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RenderSpecificities = void 0;
var _react = _interopRequireDefault(require("react"));
var _formik = require("formik");
var _core = require("@material-ui/core");
var _lodash = _interopRequireDefault(require("lodash"));
var _fields = require("./fields");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var RenderSpecificities = function RenderSpecificities(props) {
  var _values$specificities;
  var _useFormikContext = (0, _formik.useFormikContext)(),
    values = _useFormikContext.values,
    setFieldValue = _useFormikContext.setFieldValue;
  var storeSpecificity = props.storeSpecificity,
    _props$fieldWidth = props.fieldWidth,
    fieldWidth = _props$fieldWidth === void 0 ? 1 : _props$fieldWidth;
  var index = _lodash.default.findIndex(values.specificities, function (elm) {
    return elm.specificity.uuid === (storeSpecificity === null || storeSpecificity === void 0 ? void 0 : storeSpecificity.specificity.uuid);
  });
  var value = (values === null || values === void 0 ? void 0 : (_values$specificities = values.specificities.find(function (item) {
    var _item$specificity, _storeSpecificity$spe;
    return (item === null || item === void 0 ? void 0 : (_item$specificity = item.specificity) === null || _item$specificity === void 0 ? void 0 : _item$specificity.uuid) === (storeSpecificity === null || storeSpecificity === void 0 ? void 0 : (_storeSpecificity$spe = storeSpecificity.specificity) === null || _storeSpecificity$spe === void 0 ? void 0 : _storeSpecificity$spe.uuid);
  })) === null || _values$specificities === void 0 ? void 0 : _values$specificities.choice) || "";
  var returnedItems = [];
  if (storeSpecificity.specificity.type === "free") {
    returnedItems.push( /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12,
      md: 12 / fieldWidth,
      key: index
    }, /*#__PURE__*/_react.default.createElement(_fields.FreeField, {
      index: index,
      value: value,
      storeSpecificity: storeSpecificity,
      isMd: props.isMd
    })));
  } else if (storeSpecificity.specificity.type === "date") {
    returnedItems.push( /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12,
      md: 12 / fieldWidth
    }, /*#__PURE__*/_react.default.createElement(_fields.DateField, {
      index: index,
      value: value,
      storeSpecificity: storeSpecificity,
      isMd: props.isMd
    })));
  } else if (storeSpecificity.specificity.type === "str") {
    returnedItems.push( /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12,
      md: 12 / fieldWidth,
      key: index
    }, /*#__PURE__*/_react.default.createElement(_fields.StrField, {
      index: index,
      value: value,
      storeSpecificity: storeSpecificity,
      isMd: props.isMd
    })));
  } else if (storeSpecificity.specificity.type === "list") {
    returnedItems.push( /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12,
      md: 12 / fieldWidth
    }, /*#__PURE__*/_react.default.createElement(_fields.ListField, {
      index: index,
      value: value,
      storeSpecificity: storeSpecificity,
      isMd: props.isMd
    })));
  } else if (storeSpecificity.specificity.type === "m_list") {
    returnedItems.push( /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12,
      md: 12 / fieldWidth
    }, /*#__PURE__*/_react.default.createElement(_fields.MListField, {
      index: index,
      value: value,
      storeSpecificity: storeSpecificity,
      isMd: props.isMd
    })));
  } else if (storeSpecificity.specificity.type === "number") {
    returnedItems.push( /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12,
      md: 12 / fieldWidth,
      key: index
    }, /*#__PURE__*/_react.default.createElement(_fields.NumberField, {
      index: index,
      value: value,
      storeSpecificity: storeSpecificity,
      isMd: props.isMd
    })));
  } else if (storeSpecificity.specificity.type === "range") {
    returnedItems.push( /*#__PURE__*/_react.default.createElement(_fields.RangeField, {
      index: index,
      storeSpecificity: storeSpecificity,
      value: value,
      isMd: props.isMd
    }));
  } else if (storeSpecificity.specificity.type === "boolean") {
    returnedItems.push( /*#__PURE__*/_react.default.createElement(_core.Grid, {
      container: true,
      alignItems: "center",
      item: true,
      xs: 12,
      md: 12 / fieldWidth
    }, /*#__PURE__*/_react.default.createElement(_fields.BooleanField, {
      index: index,
      storeSpecificity: storeSpecificity,
      value: value
    })));
  } else if (storeSpecificity.specificity.type === "document") {
    returnedItems.push( /*#__PURE__*/_react.default.createElement(_core.Grid, {
      container: true,
      alignItems: "center",
      item: true,
      xs: 12,
      md: 12 / fieldWidth
    }, /*#__PURE__*/_react.default.createElement(_fields.MultiUploader, {
      index: index,
      storeSpecificity: storeSpecificity,
      value: value
    })));
  } else if (storeSpecificity.specificity.type === "phone") {
    returnedItems.push( /*#__PURE__*/_react.default.createElement(_core.Grid, {
      container: true,
      alignItems: "center",
      item: true,
      xs: 12,
      md: 12 / fieldWidth
    }, /*#__PURE__*/_react.default.createElement(_fields.PhoneField, {
      index: index,
      storeSpecificity: storeSpecificity,
      value: value
    })));
  } else if (storeSpecificity.specificity.type === "link") {
    returnedItems.push( /*#__PURE__*/_react.default.createElement(_core.Grid, {
      container: true,
      alignItems: "center",
      item: true,
      xs: 12,
      md: 12 / fieldWidth
    }, /*#__PURE__*/_react.default.createElement(_fields.LinkField, {
      index: index,
      storeSpecificity: storeSpecificity,
      value: value
    })));
  }
  return returnedItems;
};
exports.RenderSpecificities = RenderSpecificities;